import React from 'react'
import { FeatherSVG } from 'stylist'

const Feature = props => (
  <FeatherSVG {...props}>
    <title>feature</title>
    <rect x="1" y="5" width="22" height="14" rx="7" ry="7" />
    <circle cx="16" cy="12" r="3" />
  </FeatherSVG>
)

export default Feature



// WEBPACK FOOTER //
// ./src/components/icons/Feature.js